import { invalidateQueries, useApiMutation, useApiQuery } from '@/hooks/useApiQuery';
import { intakeRequestsService } from '@/services/api/intake-requests.service';
import type {
  ClassifyIntakeRequestPayload,
  IntakeRequestDetail,
  IntakeRequestFilters,
} from '@/types/intake-request';

const QUERY_KEY = 'intake-requests';

/** Classificar/reclassificar mexe nos módulos: invalida as listas deles também. */
function invalidateAfterChange(): void {
  invalidateQueries(QUERY_KEY);
  invalidateQueries('corrective-maintenances');
  invalidateQueries('complaints');
  invalidateQueries('suggestions');
  invalidateQueries('security-incidents');
  invalidateQueries('lost-found');
}

export function useIntakeRequests(filters: IntakeRequestFilters) {
  return useApiQuery([QUERY_KEY, 'list', filters], () => intakeRequestsService.list(filters));
}

export function useIntakeRequest(id: string | null) {
  return useApiQuery([QUERY_KEY, 'detail', id ?? ''], () => intakeRequestsService.getById(id ?? ''), {
    enabled: Boolean(id),
  });
}

export function useUnclassifiedIntakeCount(enabled: boolean) {
  return useApiQuery([QUERY_KEY, 'unclassified-count'], () => intakeRequestsService.unclassifiedCount(), {
    enabled,
    refetchInterval: 60_000,
  });
}

export function useClassifyIntakeRequest() {
  return useApiMutation<IntakeRequestDetail, { id: string; payload: ClassifyIntakeRequestPayload }>(
    ({ id, payload }) => intakeRequestsService.classify(id, payload),
    { onSuccess: invalidateAfterChange },
  );
}

export function useReclassifyIntakeRequest() {
  return useApiMutation<IntakeRequestDetail, { id: string; payload: ClassifyIntakeRequestPayload }>(
    ({ id, payload }) => intakeRequestsService.reclassify(id, payload),
    { onSuccess: invalidateAfterChange },
  );
}

export function useArchiveIntakeRequest() {
  return useApiMutation<IntakeRequestDetail, string>((id) => intakeRequestsService.archive(id), {
    onSuccess: invalidateAfterChange,
  });
}

export function useUnarchiveIntakeRequest() {
  return useApiMutation<IntakeRequestDetail, string>((id) => intakeRequestsService.unarchive(id), {
    onSuccess: invalidateAfterChange,
  });
}
